import {
  S_DesktopOnly,
  S_MobileOnly,
} from "component_old/micro/responsive/responsive"
import { LinkList, S_LinkList } from "component_old/micro/view/LinkList"
import { Localization } from "libs/localization/localization"
import React from "react"
import styled from "styled-components/macro"

export const FooterLinks = (): JSX.Element => {
  const maps1: {
    title: string
    url: string
  }[] = [
    {
      title: "Namsskogan Family park",
      url: "https://map.mapheim.com/namsskogan",
    },
    {
      title: "Jotunheimen e-sport",
      url: "https://map.mapheim.com/jotunheimen",
    },
    {
      title: "NTNUI Koiene",
      url: "https://map.mapheim.com/koiene",
    },
    {
      title: "Teknodagen",
      url: "https://map.mapheim.com/tekno",
    },
  ]

  const maps2: {
    title: string
    url: string
  }[] = [
    {
      title: "Fjellseterløpet",
      url: "https://map.mapheim.com/fjellseterlopet",
    },
    {
      title: "BM-Dagen",
      url: "https://map.mapheim.com/bm",
    },
    {
      title: "Trondheim.io",
      url: "https://map.mapheim.com/trondheim",
    },
    {
      title: "Gründerdagen",
      url: "https://map.mapheim.com/grunder",
    },
  ]

  return (
    <S_FooterLinks>
      <S_LinkCol>
        <LinkList
          title={Localization.FOOTER1}
          links={[
            {
              title: "LinkedIn",
              url: "https://www.linkedin.com/company/mapheim/",
            },
            {
              title: "Github",
              url: "https://github.com/kondulak10/react-give-me-map",
            },
          ]}
        />
        <LinkList
          title={Localization.FOOTER2}
          links={[
            {
              title: "6AM",
              url: "https://www.6am.no/",
            },
            {
              title: "Proneo",
              url: "https://proneo.no/",
            },
            {
              title: "ConnectMidt",
              url: "https://www.connectmidt.no/",
            },
          ]}
        />
      </S_LinkCol>
      <S_LinkCol>
        <LinkList
          title={Localization.FOOTER3}
          links={[
            {
              title: Localization.TERMS,
              url: "/terms",
              target: "_self",
            },
            {
              title: Localization.PRIVACY,
              url: "/privacy",
              target: "_self",
            },
            // {
            //     title: Localization.COOKIE,
            //     url: '#'
            // },
            {
              title: "",
              url: "",
            },
            {
              title: "",
              url: "",
            },
          ]}
        />
        <S_MobileOnly>
          <LinkList title={Localization.FOOTER4} links={maps1.concat(maps2)} />
        </S_MobileOnly>
      </S_LinkCol>
      <S_DesktopOnly>
        <S_LinkCol>
          <LinkList title={Localization.FOOTER4} links={maps1} />
          <LinkList title="" links={maps2} />
        </S_LinkCol>
      </S_DesktopOnly>
    </S_FooterLinks>
  )
}

export const S_FooterLinks = styled.div`
  display: flex;
  flex-direction: row;
`

export const S_LinkCol = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  ${S_LinkList}:nth-child(1) {
    margin: 0 0 25px 0;
  }
  @media only screen and (min-width: 1260px) {
    flex-direction: row;
    width: unset;
    ${S_LinkList} {
      width: 252px;
    }
  }
`
